import { Message as msg } from 'primeng';

export class Message implements msg {
  constructor(public severity: string, public summary: string, public detail: string) {}

  static Success(detail: string, summary?: string): msg {
    return new Message('success', summary || 'Success', detail);
  }

  static Error(detail: string, summary?: string): msg {
    return new Message('error', summary || 'Error', detail);
  }

  static Info(detail: string, summary?: string): msg {
    return new Message('info', summary || 'Info', detail);
  }

  static Warning(detail: string, summary?: string): msg {
    return new Message('warn', summary || 'Warning', detail);
  }
}
